// LivestreamSuperChatNotice.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import LivestreamSuperChatOverlay from '../container/LivestreamSuperChatOverlay.js';

import media from '../style/media.js';
import SlideInFromLeft from '../style/SlideInFromLeft.js';
import SlideOutToLeft from '../style/SlideOutToLeft.js';

export const LivestreamSuperChatNotice = ({
  streamId = '',
  noticeId = '',
  userId = '',
  text = '',
  diamonds = 0,
  noticeStatus = 'display',
}) => {
  if (!userId || !diamonds) return null;

  return (
    <StyledLivestreamSuperChatNotice $status={noticeStatus}>
      <LivestreamSuperChatOverlay
        key={noticeId}
        streamId={streamId}
        userId={userId}
        text={text}
        diamonds={diamonds}
      />
    </StyledLivestreamSuperChatNotice>
  );
};

LivestreamSuperChatNotice.propTypes = {
  streamId: PropTypes.string,
  noticeId: PropTypes.string,
  userId: PropTypes.string,
  text: PropTypes.string,
  diamonds: PropTypes.number,
  noticeStatus: PropTypes.string,
};

const StyledLivestreamSuperChatNotice = styled.div`
  display: inline-flex;
  align-items: center;
  max-width: 328px;
  margin-bottom: 8px;

  ${({ $status }) => {
    if ($status === 'coming') {
      return css`
        animation: 0.5s ${SlideInFromLeft};
      `;
    } else if ($status === 'leaving') {
      return css`
        animation: 0.6s ${SlideOutToLeft};
      `;
    }
  }}

  ${media.tablet`
    display: block;
    max-width: none;
  `};
`;

export default LivestreamSuperChatNotice;
